module.exports = __webpack_public_path__ + "static/media/proj4_img8.1c1b2f8b.jpg";